import React from "react";

import { Link } from "react-router";
import {
  Checkbox,
  TextField,
  RaisedButton,
  RadioButtonGroup,
  RadioButton
} from "material-ui";

import { makeFilmDetailString, dashify } from "../util";
import browserRequest from "superagent";
import debounce from "lodash/debounce";

import BackButton from "./partials/back-button.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import DroppableImage from "./partials/droppable-image.jsx";
import SubfieldsField from "./partials/subfields-field.jsx";
import InjectedSelect from "./partials/injected-select.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import Label from "./partials/label.jsx";
import LinkLike from "./partials/link-like.jsx";
import { TitleDeliveryStatus } from "./partials/film-table.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";

import BasicHtmlField from "./partials/basic-html-field.jsx";
import EventivalBanner from "./partials/eventival-banner.jsx";
import InviteContentCreatorOverlay from "./partials/overlays/invite-content-creator.jsx";
import AddExternalVirtualContentOverlay from "./partials/overlays/add-external-virtual-content.jsx";
import VirtualContentPreviewOverlay from "./partials/overlays/virtual-content-preview.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";
import AutoComplete from "material-ui/AutoComplete";
import MenuItem from "material-ui/MenuItem";

// SYNC WITH FRONTEND/COMPONENTS/FILM
const DETAILS = {
  year: "Year",
  runtime: "Runtime (min)",
  language: "Language",
  country: "Country",
  premiere: "Premiere",
  rating: "Rating",
  genre: "Genre",
  subtitle_language: "Subtitle Language",
  content_warning: "Content Warning",
  sponsor: "Sponsor",
  awards: "Awards",
  note: "Note",
  facebook: "Facebook URL",
  twitter: "Twitter URL",
  instagram: "Instagram URL"
};

const CREDITS = {
  director: "Director",
  screenwriter: "Screenwriter",
  producer: "Producer",
  executive_producer: "Executive Producer",
  co_producer: "Co-Producer",
  filmmaker: "Filmmaker",
  cast: "Cast",
  cinematographer: "Cinematographer",
  editor: "Editor",
  animator: "Animator",
  production_design: "Production Design",
  composer: "Composer",
  sound_design: "Sound Design",
  music: "Music"
};
// END SYNC

const THEMOVIEDB_BASE_URL = "https://api.themoviedb.org/3";

class FilmEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasFocusedTitle: false,
      isFetchingFilm: false,
      isInvitingContentCreator: false,
      inviteMode: "classic", // 'classic' | 'title'
      isAddingExternalVirtualContent: false,
      dirty: false,
      film: {},
      showAutocomplete: false,
      searchText: "",
      autocompleteFilms: [],
      imageUrl: "https://image.tmdb.org/t/p/",
      imageSize: "original"
      //isFilmPreviewer:
      //  UserStore.hasPermission("view_film") &&
      //  !UserStore.hasPermission("edit_film")
    };

    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this._makeLiveLink = this._makeLiveLink.bind(this);
    this.onSearchTextChange = debounce(this.onSearchTextChange.bind(this), 250);
    this.onFilmTitleSelect = debounce(this.onFilmTitleSelect.bind(this), 250);
  }

  static getStores() {
    return [EventBucketStore, FilmStore];
  }

  static getPropsFromStores() {
    return {
      getFilmById: FilmStore.getFilmById,
      uploadingImageField: FilmStore.getState().uploadingImageField
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentWillMount() {
    let configRequest = browserRequest["get"](
      `${THEMOVIEDB_BASE_URL}/configuration?api_key=${process.env.THEMOVIEDB_API_KEY}`
    );

    configRequest.end(
      function (err, response) {
        if (err) {
          console.log(err.message);
        } else {
          this.setState({
            imageUrl: response.body.images.secure_base_url,
            imageSize: response.body.images.poster_sizes[0]
          });
        }
      }.bind(this)
    );

    configRequest.send();
  }

  componentDidMount() {
    this.context.router.setRouteLeaveHook(this.props.route, () => {
      if (this.state.dirty) {
        return "Are you sure you wish to leave the film editor? Your changes will not be saved.";
      }
    });

    FilmActions.fetchOne(this.props.params.filmId);
    this.setState({ isFetchingFilm: true }, () => {
      this.componentWillReceiveProps(this.props);
    });
  }

  componentWillReceiveProps(newProps) {
    let film = newProps.getFilmById(newProps.params.filmId);

    if (!this.state.isFetchingFilm && !film) {
      FilmActions.fetchOne(newProps.params.filmId);
      this.setState({ isFetchingFilm: true });
    } else if (film) {
      this.setState({ isFetchingFilm: false, film });
      if (!this.state.hasFocusedTitle) {
        this.setState({ hasFocusedTitle: true });
        if (!film.name) {
          setTimeout(() => this.title && this.title.focus(), 100);
        }
      }
    }

    if (
      film &&
      (!this.state.values ||
        this.state.film.id !== newProps.params.filmId ||
        (this.state.isSaving && film.updated_at !== this.state.lastUpdatedAt))
    ) {
      this.setState({
        dirty: false,
        isSaving: false,
        values: film
          ? {
              name: film.name,
              details: film.details,
              credits: film.credits,
              expanded_credits: (
                film.expanded_credits &&
                film.expanded_credits.length &&
                film.expanded_credits.length > 0
              ) ? film.expanded_credits : null,
              tags: film.tags.map(t => t.id),
              trailer_url: film.trailer_url,
              description: film.description,
              short_description: film.short_description,
              visibility: film.visibility,
              unballoted: film.unballoted,
              virtual_content_disclaimer: film.virtual_content_disclaimer
            }
          : {}
      });
    }
  }

  save() {
    let values = Object.assign({}, this.state.values);
    this.setState({
      isSaving: true,
      lastUpdatedAt: this.state.film.updated_at
    });
    FilmActions.edit.defer(this.props.params.filmId, values);
    window.scrollTo(0, 0);
  }

  delete() {
    let bucket = this.state.film.event_bucket;
    if (window.confirm("Are you sure you would like to delete this film?")) {
      FilmActions.delete(this.props.params.filmId);
      this.context.router.push(
        `/event_buckets/${bucket.id ? bucket.id : bucket}/films`
      );
    }
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    this.state.values[id] = value;
    this.setState(this.state);
  }

  onSearchTextChange(searchText) {
    let f = this.state.film;
    this.setState({
      searchText: searchText
    });

    if (!searchText || searchText.length < 3) {
      return;
    }

    var req = browserRequest["get"](
      `${THEMOVIEDB_BASE_URL}/search/movie?api_key=${process.env.THEMOVIEDB_API_KEY}&query=${searchText}`
    );

    req.end(
      function (err, response) {
        if (err) {
          console.log(err.message);
        } else {
          const films = response.body.results.map(f => {
            f.detailedTitle = (
              <MenuItem
                className="tmdb-wrapper"
                primaryText={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={`${this.state.imageUrl}${this.state.imageSize}${f.poster_path}`}
                      width="14"
                      height="19"
                    />
                    <div style={{ flex: 1, marginLeft: 8 }}>
                      {f.title} (
                      {f.release_date
                        ? f.release_date.substring(0, 4)
                        : "Unknown"}
                      )
                    </div>
                  </div>
                }
              />
            );

            return f;
          });
          this.setState({
            autocompleteFilms: films,
            searchText: ""
          });
        }
      }.bind(this)
    );

    req.send();
  }

  async onFilmTitleSelect(film) {
    if (typeof film === "string") {
      this.onChangeValue("name", film);
      return;
    }

    this.onChangeValue("name", film.title);
    let f = this.state.film;

    let req1 = browserRequest["get"](
      `${THEMOVIEDB_BASE_URL}/movie/${film.id}?api_key=${process.env.THEMOVIEDB_API_KEY}`
    );

    req1.end(
      function (err, response) {
        if (err) {
          console.log(err.message);
        } else {
          let details = this.state.values.details;

          this.onChangeValue("description", response.body.overview);

          details.year = response.body.release_date
            ? response.body.release_date.substring(0, 4)
            : null;
          details.runtime = response.body.runtime;
          details.language = null;
          if (response.body.spoken_languages.length > 0) {
            response.body.spoken_languages.map(lang => {
              if (!details.language) {
                details.language = lang.english_name;
              } else {
                details.language = details.language + ", " + lang.english_name;
              }
            });
          }

          this.onChangeValue("details", details);
          this.onChangeValue("imdb_id", response.body.imdb_id);
        }
      }.bind(this)
    );

    req1.send();

    let req2 = browserRequest["get"](
      `${THEMOVIEDB_BASE_URL}/movie/${film.id}/credits?api_key=${process.env.THEMOVIEDB_API_KEY}`
    );

    req2.end(
      function (err, response) {
        if (err) {
          console.log(err.message);
        } else {
          let credits = this.state.values.credits;

          const addCredit = function (currentCredit, newCredit) {
            if (!currentCredit) {
              return newCredit;
            } else {
              return currentCredit + ", " + newCredit;
            }
          };

          // Process Crew
          const roles = Object.keys(CREDITS);
          roles.map(r => {
            credits[r] = null;
          });

          const creditMap = {
            director: "director",
            "executive producer": "executive_producer",
            producer: "producer",
            "co-producer": "co_producer",
            "director of photography": "cinematographer",
            cinematographer: "cinematographer",
            editor: "editor",
            "production design": "production_design",
            "music supervisor": "music",
            "original music composer": "composer",
            "sound designer": "sound_design",
            animation: "animator",
            screenplay: "screenwriter",
            writer: "screenwriter"
          };

          for (let cr = 0; cr < response.body.crew.length; cr++) {
            const crew = response.body.crew[cr];
            const destinationField = creditMap[crew.job.toLowerCase()];
            if (destinationField) {
              credits[destinationField] = addCredit(
                credits[destinationField],
                crew.name
              );
            }
          }

          // Process Cast
          if (response.body.cast && response.body.cast.length > 0) {
            let castLength = 3;
            if (response.body.cast.length < 3) {
              castLength = response.body.cast.length;
            }
            for (let cl = 0; cl < castLength; cl++) {
              credits.cast = addCredit(
                credits.cast,
                response.body.cast[cl].name
              );
            }
          }

          // Update Credits state object
          this.onChangeValue("credits", credits);
        }
      }.bind(this)
    );

    req2.send();

    if (film.poster_path) {
      // Update poster
      let poster = await this.getBase64ImageFromUrl(
        this.state.imageUrl + "original" + film.poster_path
      );
      f.poster_image = poster.file;
      this.onChangeValue("poster_image", poster.file);
    }
    if (film.backdrop_path) {
      // Update both cover image (for native site) and poster image (for virtual)
      let cover = await this.getBase64ImageFromUrl(
        this.state.imageUrl + "original" + film.backdrop_path
      );
      f.cover_image = cover.file;
      this.onChangeValue("cover_image", cover.file);
      f.still_image = cover.file;
      this.onChangeValue("still_image", cover.file);
    }

    this.setState({
      film: f
    });
  }

  onDropImage(id, file) {
    FilmActions.editImage.defer(this.props.params.filmId, id, file);
  }

  onRemoveImage(id) {
    FilmActions.editImage.defer(this.props.params.filmId, id, null);
  }

  _makeLiveLink() {
    const bucket = EventBucketStore.getEventBucketById(
      this.props.params.eventBucketId
    );
    if (bucket) {
      let slug = bucket.frontend_config.urls_use_slugs
        ? `${dashify(
            this.state.values ? this.state.values.name : this.state.film.name
          )}-`
        : "";
      return `${
        EventBucketStore.getEventBucketById(this.props.params.eventBucketId)
          .urls.film_guide
      }/${slug}${this.props.params.filmId}`;
    } else {
      return null;
    }
  }

  _deliverDirectly() {
    this.context.router.push(
      `/accept_creator_invite?token=${encodeURIComponent(
        `self-${this.props.params.filmId}`
      )}`
    );
  }

  getStyles() {
    return {
      leftSidebar: {
        width: 269,
        boxSizing: "border-box",
        float: "left"
      },
      leftBody: {
        padding: "1em",
        borderRadius: 5,
        backgroundColor: "#ececec",
        marginBottom: "1em"
      },
      leftHeader: {
        textAlign: "center"
      },
      leftHeaderTitle: {
        marginBottom: 0
      },
      leftHeaderSubtitle: {
        fontWeight: "normal",
        fontSize: "1em",
        marginTop: 0
      },
      posterImage: {
        width: 140,
        borderRadius: 5,
        display: "inline-block"
      },
      coverImage: {
        minHeight: 140,
        marginTop: "1em",
        borderRadius: 5
      },
      main: {
        marginLeft: 291,
        boxSizing: "border-box"
      }
    };
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          resolve({
            file: reader.result,
            uploadBlob: blob
          });
        },
        false
      );

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
  }

  render() {
    const styles = this.getStyles(),
      bucket = EventBucketStore.getEventBucketById(
        this.props.params.eventBucketId
      ),
      hasTitleRequest =
        this.state.film.title_requested_media &&
        this.state.film.title_requested_media.length;

    if (
      !this.state.film ||
      !this.state.values ||
      this.state.isSaving ||
      !bucket
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    let saveButton = (
      <RaisedButton
        label={this.state.dirty ? "Save changes" : "No changes to save"}
        primary={true}
        disabled={!this.state.dirty}
        onTouchTap={this.save}
      />
    );

    let detailString = makeFilmDetailString(this.state.values.details);

    let stillEditor = (
      <DroppableImage
        style={Object.assign(
          {},
          styles.coverImage,
          this.state.film.still_image && { minHeight: "auto" }
        )}
        label={bucket.frontend_config.film_guide_stills_mode ? "Still image for film guide and virtual screening" : "Still image for virtual screening"}
        subsublabel={
          !this.state.film.still_image && "Recommended size: 1920 x 1080 px"
        }
        isUploading={this.props.uploadingImageField === "still_image"}
        value={this.state.film.still_image}
        crop={{ width: 1920, height: 1080 }}
        onDrop={f => this.onDropImage("still_image", f)}
        onDelete={() => this.onRemoveImage("still_image")}
      />
    );

    const isReadOnly =
      UserStore.hasPermission("view_film") &&
      !UserStore.hasPermission("edit_film");

    return (
      <div>
        {this.state.isPreviewingVirtualContent ? (
          <VirtualContentPreviewOverlay
            filmId={this.state.film.id}
            onRequestClose={() =>
              this.setState({ isPreviewingVirtualContent: false })
            }
          />
        ) : null}

        {this.state.isInvitingContentCreator ? (
          <InviteContentCreatorOverlay
            eventBucket={bucket}
            film={this.state.film}
            inviteMode={this.state.inviteMode}
            onInvite={(email, { title_requested_media }) => {
              FilmActions.inviteContentCreator(
                this.state.film.id,
                email,
                this.state.inviteMode === "title"
                  ? {
                      title_requested_media
                    }
                  : undefined
              );
              this.setState({ isInvitingContentCreator: false });
            }}
            onRequestClose={() =>
              this.setState({ isInvitingContentCreator: false })
            }
          />
        ) : null}
        {this.state.isAddingExternalVirtualContent ? (
          <AddExternalVirtualContentOverlay
            eventBucket={bucket}
            film={this.state.film}
            onCreate={virtualContent => {
              this.setState(
                {
                  values: {
                    ...this.state.values,
                    virtual_content: virtualContent.id
                  }
                },
                () => {
                  this.save();
                  this.setState({ isAddingExternalVirtualContent: false });
                }
              );
            }}
            onRequestClose={() =>
              this.setState({ isAddingExternalVirtualContent: false })
            }
          />
        ) : null}
        <div style={styles.leftSidebar}>
          <div style={styles.leftBody}>
            <div style={styles.leftHeader}>
              {!bucket.frontend_config.film_guide_stills_mode ? (isReadOnly ? (
                <div
                  style={Object.assign(
                    {},
                    styles.posterImage,
                    this.state.film.poster_image && { minHeight: "auto" }
                  )}
                >
                  {this.state.film.poster_image ? (
                    <img
                      src={this.state.film.poster_image}
                      style={{ width: "100%", borderRadius: 5 }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 140,
                        height: 200,
                        backgroundColor: "#adadad",
                        borderRadius: 5,
                        textAlign: "center",
                        paddingTop: 90,
                        boxSizing: "border-box"
                      }}
                    >
                      No Poster Image
                    </div>
                  )}
                </div>
              ) : (
                <DroppableImage
                  style={Object.assign(
                    {},
                    styles.posterImage,
                    !this.state.film.poster_image && { minHeight: 200 }
                  )}
                  label="Poster image"
                  isUploading={
                    this.props.uploadingImageField === "poster_image"
                  }
                  value={this.state.film.poster_image}
                  onDrop={f => this.onDropImage("poster_image", f)}
                  onDelete={() => this.onRemoveImage("poster_image")}
                />
              )) : null}
              <h2 style={styles.leftHeaderTitle}>
                {this.state.values.name || "Untitled Film"}
              </h2>
              <h3 style={styles.leftHeaderSubtitle}>{detailString}</h3>
            </div>
            {!bucket.frontend_config.film_guide_stills_mode ? (
              isReadOnly ? (
                <div
                  style={Object.assign(
                    {},
                    styles.coverImage,
                    this.state.film.cover_image && { minHeight: "auto" }
                  )}
                >
                  {this.state.film.cover_image ? (
                    <img
                      src={this.state.film.cover_image}
                      style={{ width: "100%", borderRadius: 5 }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 243,
                        height: 146,
                        backgroundColor: "#adadad",
                        borderRadius: 5,
                        textAlign: "center",
                        paddingTop: 65,
                        marginBottom: 15,
                        boxSizing: "border-box"
                      }}
                    >
                      No Cover Image
                    </div>
                  )}
                </div>
              ) : (
                <DroppableImage
                  style={[
                    styles.coverImage,
                    this.state.film.cover_image && { minHeight: "auto" }
                  ]}
                  label="Cover image"
                  isUploading={this.props.uploadingImageField === "cover_image"}
                  value={this.state.film.cover_image}
                  crop={{ width: 960, height: 380 }}
                  subsublabel={
                    !this.state.film.cover_image &&
                    "Recommended size: 960 x 380 px"
                  }
                  onDrop={f => this.onDropImage("cover_image", f)}
                  onDelete={() => this.onRemoveImage("cover_image")}
                />
              )
            ) : null}
            {bucket.enable_virtual_festival || bucket.frontend_config.film_guide_stills_mode ? (
              isReadOnly ? (
                this.state.film.still_image ? (
                  <div
                    style={Object.assign(
                      {},
                      styles.stillImage,
                      this.state.film.still_image && { minHeight: "auto" }
                    )}
                  >
                    <img
                      src={this.state.film.still_image}
                      style={{ width: "100%", borderRadius: 5 }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      width: 243,
                      height: 146,
                      backgroundColor: "#adadad",
                      borderRadius: 5,
                      textAlign: "center",
                      paddingTop: 65,
                      marginBottom: 0,
                      boxSizing: "border-box"
                    }}
                  >
                    No Still Image
                  </div>
                )
              ) : (
                stillEditor
              )
            ) : null}
          </div>
          {bucket.enable_title_delivery ? (
            <div style={styles.leftBody}>
              <Label style={{ marginTop: 0 }}>
                Eventive Print Traffic
                <InlineNoticeLabel
                  label="Limited Beta"
                  style={{
                    marginLeft: 6,
                    fontWeight: "bold"
                  }}
                />
              </Label>
              {this.state.film.title ? (
                <div>
                  <TitleDeliveryStatus film={this.state.film} />
                  {this.state.film.title_delivery.status_description ? (
                    <div style={{ fontStyle: "italic" }}>
                      {this.state.film.title_delivery.status_description}
                    </div>
                  ) : null}
                  <div>
                    Delivery identifier:{" "}
                    <span style={{ fontFamily: "monospace, sans-serif" }}>
                      {this.state.film.title_delivery.delivery_identifier}
                    </span>
                  </div>
                  {this.state.film.title_delivery.submitting_user_account ? (
                    <div>
                      Submitter:{" "}
                      {
                        this.state.film.title_delivery.submitting_user_account
                          .name
                      }{" "}
                      (
                      <a
                        href={`mailto:${this.state.film.title_delivery.submitting_user_account.email}`}
                        style={{ wordBreak: "break-all" }}
                      >
                        {
                          this.state.film.title_delivery.submitting_user_account
                            .email
                        }
                      </a>
                      )
                    </div>
                  ) : null}
                  {this.state.film.title_delivery.print_delivery_type ? (
                    <div>
                      Print delivery:{" "}
                      <span style={{ fontFamily: "monospace, sans-serif" }}>
                        {this.state.film.title_delivery.print_delivery_type}
                      </span>
                    </div>
                  ) : null}
                  {this.state.film.title_delivery.virtual_delivery_type ? (
                    <div>
                      Virtual delivery:{" "}
                      <span style={{ fontFamily: "monospace, sans-serif" }}>
                        {this.state.film.title_delivery.virtual_delivery_type}
                      </span>
                    </div>
                  ) : null}
                  <div>
                    <LinkLike onTouchTap={() => this._deliverDirectly()}>
                      Deliver directly
                    </LinkLike>{" "}
                    &middot;{" "}
                    <LinkLike
                      onTouchTap={() => {
                        this.setState({
                          isInvitingContentCreator: true,
                          inviteMode: "title"
                        });
                      }}
                    >
                      Send new invite
                    </LinkLike>
                  </div>
                </div>
              ) : (
                <div>
                  <div style={{ fontWeight: "bold" }}>
                    {hasTitleRequest ? (
                      <div>
                        Title request sent:{" "}
                        {this.state.film.title_requested_media
                          .sort()
                          .join(", ")}
                      </div>
                    ) : (
                      "No title connected"
                    )}
                  </div>
                  {hasTitleRequest &&
                  this.state.film._content_creator_invites &&
                  this.state.film._content_creator_invites.length ? (
                    <div>
                      Invite sent to{" "}
                      {this.state.film._content_creator_invites
                        .map(i => i.email)
                        .join(", ")}
                    </div>
                  ) : null}
                  <div>
                    <RaisedButton
                      label="Send delivery invite"
                      primary={true}
                      onTouchTap={() =>
                        this.setState({
                          isInvitingContentCreator: true,
                          inviteMode: "title"
                        })
                      }
                      style={{ margin: "5px 0" }}
                    />
                  </div>
                  <div>
                    <LinkLike onTouchTap={() => this._deliverDirectly()}>
                      Deliver directly
                    </LinkLike>
                  </div>
                </div>
              )}
            </div>
          ) : null}

          {bucket.enable_virtual_festival ? (
            this.state.isFilmPreviewer ? null : (
              <div style={styles.leftBody}>
                <Label style={{ marginTop: 0 }}>Virtual content</Label>
                {this.state.film.virtual_content ? (
                  <div>
                    {this.state.film.virtual_content.type === "external" ? (
                      <div>
                        <strong>External content</strong>:{" "}
                        <a
                          href={this.state.film.virtual_content.egress_url}
                          target="_blank"
                          style={{ wordBreak: "break-all", color: "#000" }}
                        >
                          {this.state.film.virtual_content.egress_url}
                        </a>
                      </div>
                    ) : this.state.film.virtual_content.type === "vod" ? (
                      <div>
                        <strong>VOD content</strong>:{" "}
                        <span style={{ wordBreak: "break-all" }}>
                          {this.state.film.virtual_content.label}
                        </span>{" "}
                        {this.state.film.virtual_content.platform ===
                          "cinesend" ||
                        this.state.film.virtual_content.platform ===
                          "eventive" ? (
                          <div
                            style={{
                              fontWeight: "bold",
                              color: "rgb(229, 57, 53)"
                            }}
                          >
                            No longer supported – re-upload required{" "}
                            <a
                              href="https://help.eventive.org/en/articles/5292118-legacy-asset-pathway-deprecation-information-may-2021"
                              target="_blank"
                            >
                              (?)
                            </a>
                          </div>
                        ) : (
                          <span>
                            ({this.state.film.virtual_content.status}
                            {this.state.film.virtual_content.platform &&
                            UserStore.isGod()
                              ? ` - ${this.state.film.virtual_content.platform}`
                              : ""}
                            )
                          </span>
                        )}
                      </div>
                    ) : (
                      <div>
                        Unexpected virtual content encountered! Please contact
                        Eventive Support.
                      </div>
                    )}
                    {this.state.film.virtual_content.caption_tracks &&
                    this.state.film.virtual_content.caption_tracks.length ? (
                      <div style={{ margin: "4px 0" }}>
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          style={{
                            width: 24,
                            height: 24,
                            verticalAlign: -3,
                            margin: "-4px 0 -4px -2px"
                          }}
                        >
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z" />
                        </svg>{" "}
                        Closed captions available
                      </div>
                    ) : null}
                    {isReadOnly ? null : (
                      <LinkLike
                        onTouchTap={() => {
                          if (
                            this.state.film.virtual_content.type ===
                              "external" ||
                            window.confirm(
                              "Are you sure? You will need to re-request permission from the filmmaker to re-upload."
                            )
                          ) {
                            this.setState(
                              {
                                values: {
                                  ...this.state.values,
                                  virtual_content: null
                                }
                              },
                              () => this.save()
                            );
                          }
                        }}
                      >
                        Remove
                      </LinkLike>
                    )}
                    {isReadOnly ? null : <span> &middot; </span>}
                    <LinkLike
                      onTouchTap={() => {
                        this.setState({ isPreviewingVirtualContent: true });
                      }}
                    >
                      Preview
                    </LinkLike>{" "}
                    {this.state.film.virtual_content.type === "vod" ? (
                      isReadOnly ? null : (
                        <span>
                          &middot;{" "}
                          <Link
                            to={`/creator_hub/virtual_content/${this.state.film.virtual_content.id}`}
                          >
                            Manage
                          </Link>
                        </span>
                      )
                    ) : null}
                  </div>
                ) : (
                  <div>
                    <div style={{ fontWeight: "bold" }}>
                      No virtual content uploaded
                      {hasTitleRequest &&
                      this.state.film.title_requested_media.includes("virtual")
                        ? `, awaiting delivery from Eventive Print Traffic`
                        : ""}
                    </div>
                    {isReadOnly ? null : hasTitleRequest ? (
                      <span>
                        <LinkLike
                          onTouchTap={() =>
                            this.setState({
                              isInvitingContentCreator: true,
                              inviteMode: "classic"
                            })
                          }
                        >
                          Send virtual content upload invite
                        </LinkLike>{" "}
                        &middot;
                      </span>
                    ) : (
                      <div>
                        {this.state.film._content_creator_invites &&
                        this.state.film._content_creator_invites.length ? (
                          <div>
                            Invite sent to{" "}
                            {this.state.film._content_creator_invites
                              .map(i => i.email)
                              .join(", ")}
                          </div>
                        ) : null}
                        <div>
                          <RaisedButton
                            label="Send upload invite"
                            primary={true}
                            onTouchTap={() =>
                              this.setState({
                                isInvitingContentCreator: true,
                                inviteMode: "classic"
                              })
                            }
                            style={{ margin: "5px 0" }}
                          />
                        </div>
                      </div>
                    )}
                    {isReadOnly ? null : (
                      <div>
                        {hasTitleRequest ? null : `or `}
                        <Link to={`/creator_hub/films/${this.state.film.id}`}>
                          {hasTitleRequest ? "U" : "u"}pload directly
                        </Link>{" "}
                        &middot;{" "}
                        <LinkLike
                          onTouchTap={() =>
                            this.setState({
                              isAddingExternalVirtualContent: true
                            })
                          }
                        >
                          Use external link
                        </LinkLike>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          ) : null}
          <div style={styles.leftBody}>
            <TextField
              value={this.state.values.trailer_url || ""}
              floatingLabelText="Trailer URL"
              floatingLabelFixed={true}
              style={{ marginTop: -12, marginBottom: -6, width: "100%" }}
              placeholder="YouTube or Vimeo link"
              onChange={e => this.onChangeValue("trailer_url", e.target.value)}
              disabled={isReadOnly}
            />
          </div>
          {UserStore.hasPermission("manage_films") ||
          UserStore.hasPermission("edit_film") ? (
            <div style={styles.leftBody}>
              <div>
                <Label style={{ marginTop: 0 }}>Visibility</Label>
                <RadioButtonGroup
                  name="visibility"
                  valueSelected={this.state.values.visibility}
                  onChange={(e, v) => this.onChangeValue("visibility", v)}
                >
                  <RadioButton value="visible" label="Visible everywhere" />
                  <RadioButton value="hidden" label="Hidden from Film Guide" />
                  <RadioButton
                    value="hidden_everywhere"
                    label="Hidden everywhere"
                  />
                </RadioButtonGroup>
                {bucket && bucket.enable_virtual_festival ? (
                  <div
                    style={{
                      marginTop: "0.75em",
                      fontStyle: "italic",
                      fontSize: "0.9em",
                      lineHeight: "1.3",
                      opacity: 0.7
                    }}
                  >
                    <strong>Eventive Virtual note:</strong> If set to "Hidden
                    everywhere" and added to a virtual screening, the film will
                    not be shown in the sidebar but will still play within the
                    program.
                  </div>
                ) : null}
              </div>
              {bucket && bucket.enable_virtual_festival ? (
                <div>
                  <Label>Age-restricted content</Label>
                  <Checkbox
                    labelStyle={{ lineHeight: "18px" }}
                    label={`Viewers must attest to being 18+ to view virtual content`}
                    checked={this.state.values.virtual_content_disclaimer ? true : false}
                    onCheck={(e, checked) => {
                      this.onChangeValue(
                        "virtual_content_disclaimer",
                        checked ? "disclaimer" : null
                      )
                    }}
                  />
                </div>
              ) : null}
              {bucket && bucket.enable_balloting ? (
                <div>
                  <Label>Balloting status</Label>
                  <RadioButtonGroup
                    name="unballoted"
                    valueSelected={
                      this.state.values.unballoted ? "unballoted" : "balloted"
                    }
                    onChange={(e, v) =>
                      this.onChangeValue(
                        "unballoted",
                        v === "unballoted" ? true : false
                      )
                    }
                  >
                    <RadioButton value="balloted" label="Balloted" />
                    <RadioButton
                      value="unballoted"
                      label="Not in competition"
                    />
                  </RadioButtonGroup>
                </div>
              ) : null}
            </div>
          ) : null}
          <div style={{ marginTop: 15, display: "flex", alignItems: "center" }}>
            <img
              src="/img/tmdb.svg"
              style={{ width: 30, height: 22, marginRight: 10 }}
            />
            <div style={{ fontSize: 10, lineHeight: "10px" }}>
              This product uses the{" "}
              <a href="https://www.themoviedb.org/" target="_blank">
                TMDb
              </a>{" "}
              API but is not endorsed or certified by TMDb.
            </div>
          </div>
        </div>
        <div style={styles.main}>
          <div>
            <BackButton
              label="Films"
              onTouchTap={() =>
                this.props.location.state &&
                this.props.location.state.fromListing
                  ? this.context.router.goBack()
                  : this.context.router.push(
                      `/event_buckets/${this.props.params.eventBucketId}/films`
                    )
              }
              style={{ marginRight: 7 }}
            />
            {saveButton}
            <RaisedButton
              style={{ marginLeft: 7, verticalAlign: "top" }}
              disabled={this.state.dirty}
              label="View live"
              target="_blank"
              href={this._makeLiveLink()}
            />
          </div>
          {this.state.film.eventival_id && (
            <EventivalBanner
              type="film"
              style={{ marginTop: 20, marginBottom: -10 }}
            />
          )}
          <InfoNotice style={{ marginTop: 20 }}>
            Check out our{" "}
            <a
              href="http://help.eventive.org/films/create-films"
              target="_blank"
            >
              guide to creating films
            </a>
            .
          </InfoNotice>
          {bucket.frontend_config.disable_tmdb_integration ? (
            <TextField
              floatingLabelText="Film title"
              floatingLabelFixed={true}
              style={{ width: "100%" }}
              value={this.state.values.name}
              onChange={e => this.onChangeValue("name", e.target.value)}
              disabled={isReadOnly}
            />
          ) : (
            <AutoComplete
              floatingLabelText="Film title"
              floatingLabelFixed={true}
              searchText={this.state.values.name}
              dataSource={this.state.autocompleteFilms || []}
              dataSourceConfig={{ text: "title", value: "detailedTitle" }}
              filter={(searchText, key) =>
                searchText &&
                key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
              }
              maxSearchResults={8}
              menuProps={{ desktop: true, autoWidth: true, width: "auto" }}
              style={{
                width: "100%"
              }}
              fullWidth={true}
              onNewRequest={this.onFilmTitleSelect}
              onUpdateInput={this.onSearchTextChange}
              onBlur={e => {
                if (this.state.searchText !== "") {
                  this.onFilmTitleSelect(this.state.searchText);
                }
                else {
                  this.onChangeValue("name", e.target.value);
                }
              }}
              disabled={isReadOnly}
            />
          )}
          {isReadOnly ? (
            <div>
              <Label style={{ color: "#a4a4a4" }}>Film description</Label>
              <div
                style={{ color: "#868686", fontSize: "16px" }}
                dangerouslySetInnerHTML={{
                  __html: this.state.values.description
                }}
              ></div>
            </div>
          ) : (
            <BasicHtmlField
              label="Film description"
              value={this.state.values.description}
              formats={["image", "align"]}
              onChange={v => this.onChangeValue("description", v)}
              withImages={true}
            />
          )}
          <TextField
            floatingLabelText="Short description (logline)"
            floatingLabelFixed={true}
            style={{ width: "100%" }}
            placeholder="Start typing to add – shown in Film Guide, Virtual Catalog, and Eventive Discovery Portal"
            value={this.state.values.short_description}
            onChange={e =>
              this.onChangeValue("short_description", e.target.value)
            }
            disabled={isReadOnly}
          />
          <InjectedSelect
            label="Tags"
            value={this.state.values.tags}
            types={["tags"]}
            multi={true}
            noResultsText={
              <span>
                No tags found. Use the{" "}
                <Link
                  to={`event_buckets/${this.props.params.eventBucketId}/tags`}
                >
                  Tags
                </Link>{" "}
                section to create new tags.
              </span>
            }
            labelFormatter={t => t.name}
            eventBucketId={this.props.params.eventBucketId}
            style={{ width: "100%" }}
            onChange={selected => this.onChangeValue("tags", selected)}
            disabled={isReadOnly}
          />
          <div style={{ marginTop: "1em" }}>
            <SubfieldsField
              style={{ display: "inline-block", marginRight: "1em" }}
              label="Details"
              options={DETAILS}
              value={this.state.values.details}
              onChange={v => this.onChangeValue("details", v)}
              disabled={isReadOnly}
            />
            <SubfieldsField
              style={{ display: "inline-block", marginRight: "-1.5em" }}
              label="Credits"
              options={CREDITS}
              value={this.state.values.credits}
              onChange={v => this.onChangeValue("credits", v)}
              disabled={isReadOnly}
            />
          </div>
          {this.state.values.expanded_credits ? (
            <div style={{ marginTop: "1em", width: "100%" }}>
              <SubfieldsField
                style={{ display: "inline-block", marginRight: "1em", width: "100%" }}
                label="Expanded Credits"
                options={this.state.values.expanded_credits.map(ec => { return ec.label })}
                value={this.state.values.expanded_credits.map(ec => { return ec.value })}
                disabled={true}
                wider={true}
              />
            </div>
          ) : null}
          {isReadOnly ? null : (
            <div style={{ marginTop: "1em" }}>
              {saveButton}
              <RaisedButton
                label="Delete film"
                onTouchTap={this.delete}
                style={{ marginLeft: 7 }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connectToStores(FilmEditor);



// WEBPACK FOOTER //
// ./src/app/components/film-editor.jsx